import { takeLatest, put } from 'redux-saga/effects';
import { getRequest } from '../../../utilities/requests';
import {
  LOAD_REFERRAL_CRYPTO_WALLETS,
  setReferralCryptoWallets
} from './reducer';
import { history } from '../../../utilities/history';

export function* handleLoadReferralCryptoWallets() {
  try {
    const response = yield getRequest('/referral_crypto_wallet');
    yield put(setReferralCryptoWallets(response.data.referral_crypto_wallet));
  } catch (error) {
    // handle better TODO:
    history.push('/error');
  }
}

export function* loadReferralCryptoWalletsSaga() {
  yield takeLatest(
    LOAD_REFERRAL_CRYPTO_WALLETS,
    handleLoadReferralCryptoWallets
  );
}
